import React from 'react';
import cognitoConfig from "./cognitoConfig";
import { Amplify } from "aws-amplify";
import {AuthProvider} from "./features/auth/AuthContext";
const AccountLink = React.lazy(() => import('./features/account/AccountLink'));
const AccountPage = React.lazy(() => import('./features/account/AccountPage'));
const SignInOrRegister = React.lazy(() => import('./features/sign-in/SignInOrRegister'));

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: cognitoConfig.REGION,
    userPoolId: cognitoConfig.USER_POOL_ID,
    userPoolWebClientId: cognitoConfig.APP_CLIENT_ID,
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
  oauth: {
    domain: cognitoConfig.DOMAIN,
    redirectSignIn: "http://localhost:3000/",
    redirectSignOut: "http://localhost:3000/",
    responseType: "token",
  },
});

interface AuthAppProps {
  page?: 'login' | 'account';
}

function AuthApp(props: AuthAppProps):JSX.Element {
  if(props.page === 'login') {
    return <>
      <AuthProvider>
        <SignInOrRegister />
      </AuthProvider>
    </>
  }

  if(props.page === 'account') {
    return <>
      <AuthProvider>
        <AccountPage />
      </AuthProvider>
    </>
  }
  return <>
    <AuthProvider>
      <AccountLink />
    </AuthProvider>

  </>
}

export default AuthApp;